import bookaMeetingApi from "./request";
import { AxiosResponse } from "axios";
import { EventStatePayload } from "../redux/eventSlice";

type EventPayload = {
  startTime: string;
  endTime: string;
  fromTimeZone: string;
  date: string;
  duration: number;
};

export async function addeventAPI(eventData:EventStatePayload): Promise<any> {
    const save =  await bookaMeetingApi.requestWIthAuth({
      url: "/createevent",
      method: "POST",
      data:eventData,
    });
    return save.data;
    // return await getAlleventssAPI(eventData.creator_email);
  }


  export async function getAlleventssAPI(): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.requestWIthAuth({
      url: "/getevent",
      method: "GET",
      omitAuth: true,
    });    
  }
  
  export async function deleteeventAPI(Id:string): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.request({
      url: "/schedule?schedulerId="+Id,
      method: "DELETE",
      omitAuth: true,
    });
  }

  export async function geteventAPI(Id:string): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.request({
      url: "/schedule?schedulerId="+Id,
      method: "GET",
    });
  }

  export async function updateeventAPI(Id:string,scheduleData:any): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.request({
      url: "/prod/schedule?schedulerId="+Id,
      method: "PUT",
      data:scheduleData,
    });
  }

  export async function updateVideoIdEventAPI(Id:string,scheduleData:any): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.request({
      url: "/prod/schedule?schedulerId="+Id,
      method: "PUT",
      data:scheduleData,
    });
  }

      
  export async function getseventByLinkAPI(eventlink:any): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.request({
      url: "/prod/schedule?eventlink="+eventlink,
      method: "GET",
    });
  }


  export async function intervalstimeslotAPI(eventData: EventPayload): Promise<any> {
    try {
      const timeSlot = await bookaMeetingApi.request({
        url: "/intervalstimeslot", 
        method: "POST",
        data: eventData,
      });
      return timeSlot.data;
    } catch (error) {
      console.error('Error adding event:', error);
      throw error;
    }
  }

  export async function eventCustomersAPI(): Promise<AxiosResponse<any>> {
    return await bookaMeetingApi.requestWIthAuth({
      url: "/eventCustomer",
      method: "GET",
      omitAuth: true,
    });    
  }